module.exports = __webpack_public_path__ + "img/mask.9db5ee3e.svg";